import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router';
import { InlineStack, Box } from '@shopify/polaris';
import { hasPermission } from '#client/utils/helpers';
import { SessionContext } from '#client/contexts/SessionContext';

const NavLink = ({ to, label, noUnderline, requiredPermission }) => {
    const location = useLocation();
    const isActive = location.pathname.startsWith(to);
    const { currentUser } = useContext(SessionContext);
    if (typeof requiredPermission === 'string' && !hasPermission(currentUser, requiredPermission)) {
        return;
    }

    return (
        <Box className={`nav-link ${isActive ? 'nav-link--active' : ''} ${noUnderline ? 'nav-link--no-underline' : ''}`}>
            <Link to={to} prefetch="viewport" viewTransition>
                <Box display="inline-block">
                    <InlineStack blockAlign="center">{label}</InlineStack>
                </Box>
            </Link>
        </Box>
    );
};

export default NavLink;
